import React, {useState} from 'react';
import {AppProvider} from '@shopify/polaris';
import { WorksheetProvider } from '../contexts/Worksheet'
import Worksheet from './Worksheet'

export default function Display(props) {
  return (
  <AppProvider>
    <WorksheetProvider value={props.item} options={{readOnly: true, hideHeader: props.hideHeader, hideFooter: props.hideFooter }}>
      <Worksheet />
    </WorksheetProvider>
  </AppProvider>)
}
